<svelte:options runes={true} />

<script lang="ts">
  import type { KeyManager } from '@reactive';
  import { localeManager, prefs } from '@reactive';
  import { StringId } from '@strings';
  import AppLocalePicker from './AppLocalePicker.svelte';
  import ColorModePicker from './ColorModePicker.svelte';

  let { keyManager }: { keyManager: KeyManager } = $props();

  function handleSwitchChange(event: CustomEvent) {
    prefs.screencastMode = (event.target as HTMLInputElement).checked;
  }

  function switchClass() {
    return !prefs.screencastMode ? 'my-switch' : '';
  }

  function switchName() {
    return localeManager.localizedString(StringId.SCREENCAST_MODE);
  }
</script>

<style>
  .v-stack {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 12rem;
    padding: 10px;
  }

  .my-switch::part(control) {
    background: var(--fl-switch-control);
  }
</style>

<div id="RightBar" class="v-stack">
  <ColorModePicker></ColorModePicker>
  <AppLocalePicker {keyManager}></AppLocalePicker>
  <sl-switch
    class={switchClass()}
    checked={prefs.screencastMode}
    onsl-change={handleSwitchChange}
    size="small"
  >
    {switchName()}
  </sl-switch>
</div>
